import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const setHistory = createAction(ACTIONS.SET_HISTORY)<any>();
export const getHistory = createAction(ACTIONS.GET_HISTORY)();
